import React, {useState,useEffect} from 'react'
import {Modal, Button,Alert,Row,Col,Spinner} from 'react-bootstrap'
import classes from './Page1.module.css'
import axios from 'axios'

function ContactUs(props) {
  const [info,setInfo]=useState({name:"",email:"",number:"",sugg:""})
  const [valid,setValid]=useState(false)
  // let exec="https://script.google.com/macros/s/AKfycbzm_J7H0bTGYu-ObmcgwvLW7sOQFf41YLvWLpc2i8exUqCHBmlEBVOK/exec"
  // let qrystr="?id=Sheet1&Name=&Email=&Number=&Suggestions="
  const [message,setMessage]=useState(false)
  const [spin, setSpin] = useState(false)

  useEffect(()=>{
    if (valid) {
      setSpin(<Spinner animation="border" variant="primary" />)
        console.log(info)
        // const proxyurl = "https://cors-anywhere.herokuapp.com/";
        const exec="https://script.google.com/macros/s/AKfycbwY-eVnTtMlEx6pXsN8KpgPJMdm0yjMPleB94HcuTt4zuI2msOMwCfs/exec"
        const qrystr="?id=Sheet1&Name="+info.name+"&Email="+info.email+"&Number="+info.number+"&Suggestions="+info.sugg
        console.log('posting now')
        // console.log(qrystr);
        axios.get(exec+qrystr)
                .then(response =>{
                    // console.log(response)
                    setMessage(<Alert key={1} variant="success">Successfully Sent</Alert>)
                    setSpin(false)
                })
                .catch(error => {
                    console.log(error)
                    setMessage(<Alert key={0} variant="danger">Error Occured in Pushing Data</Alert>)
                    setSpin(false)
                })  
        setValid(false)
    }
    
},[info,valid])

  function validate(info){
    if (info.name!==""&&info.email!==""&&info.number!==""&&info.sugg!=="") {
      // console.log("true man")
      // console.log(props)
      setValid(true)
      // props.onHide()
      setMessage(false)
    }
    else{
      setValid(false)
      setMessage(<Alert key={0} variant="danger">Please fill in all details</Alert>)
    }
}

    return (
        <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
            Contact Us
        </Modal.Title>
      </Modal.Header>
      <Modal.Body align="left">
        <p>
          <Row>
           <Col xs={2}>Name:</Col>
           <Col xs={10}>
        <input type="text" placeholder="Your Name here" className={classes.Input} onChange={e=>setInfo({...info,name: e.target.value})}></input>
        </Col> 
        </Row>
        </p>
        <p>
          <Row>
          <Col xs={2}>E-mail:</Col>
        <Col xs={10}>
        <input type="email" placeholder="To Contact you if needed" className={classes.Input} onChange={e=>setInfo({...info,email: e.target.value})}></input>
        </Col>
        </Row>
        </p>
        <p>
          <Row>
            <Col xs={2}>Phone No:</Col>
            <Col xs={10}>
        <input type="number" placeholder="To Contact you" className={classes.Input} onChange={e=>setInfo({...info,number: e.target.value})}></input>
        </Col>
        </Row>
        </p>
        <p>
            Suggestions
        </p>
        <textarea placeholder="Your Suggestions here" style={{width:"95%", height:"90px"}} onChange={e=>setInfo({...info,sugg: e.target.value})}></textarea>
        {message}
      </Modal.Body>
      <Modal.Footer>
        {spin}
        <Button onClick={()=>{
          setValid(false)
          setMessage(false)
          props.onHide()
          }}>Close</Button>
        <Button onClick={()=>{
          // console.log(info)
          validate(info)
          }}>Send</Button>
      </Modal.Footer>
    </Modal>
    )
}

export default ContactUs
